import { useQuery } from '@tanstack/react-query';
import { getDeliverObjectReleaseIdRelease } from '../api/deliver-object-api/deliver-object-api';
import { DeliverObjectDto } from '../api/model';

export const useReleaseDeliverables = (releaseId: number) => {
  const query = useQuery({
    queryKey: [`/deliver-object/${releaseId}/release`],
    queryFn: async () => {
      if (!releaseId) return [];
      const result = await getDeliverObjectReleaseIdRelease(releaseId);

      if (!result) return [];
      if (Array.isArray(result)) return result;

      return [result];
    },
    enabled: !!releaseId && releaseId > 0,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
  
  // data working and processing
  const rawData = query.data || [];
  const deliverables = Array.isArray(rawData) ? rawData : [];
  
  // Return all deliverables for that release
  const filteredDeliverables = deliverables;

  return {
    deliverables: filteredDeliverables,
    isLoading: query.isLoading,
    error: query.error
  };
};